import {
	LaravelResponse,
	keyToUrl,
	withDestroyEndpoint,
	withIndexEndpoint,
	withShowEndpoint,
	withStoreEndpoint,
	withUpdateEndpoint,
} from "@dgs/core";
import axios from "axios";
import { Preference, PreferenceIndexResource, SortPreferencesRequest } from "../../types";

const baseKey = ["preferences"];
const allKey = baseKey;
const sortKey = [...baseKey, "sort"];

export const preferenceService = {
	allKey,
	all: () => axios.get<LaravelResponse<PreferenceIndexResource[]>>(keyToUrl(allKey)),
	...withIndexEndpoint<PreferenceIndexResource>(baseKey),
	...withShowEndpoint<Preference>(baseKey),
	...withUpdateEndpoint<Preference>(baseKey),
	...withStoreEndpoint<Preference>(baseKey),
	...withDestroyEndpoint(baseKey),
	sortKey,
	sort: (preferences: SortPreferencesRequest[]) =>
		axios.post<LaravelResponse<PreferenceIndexResource>>(keyToUrl(sortKey), { tree: preferences }),
};
